import React, { ChangeEvent, useEffect } from 'react'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import { StyledMultiSelect } from './RadioGroupButtons.styled'
import radioChecked from 'assets/images/icons/radio-checked.svg'
import radioUnchecked from 'assets/images/icons/radio-unchecked.svg'
import radioValidation from 'assets/images/icons/radio-validation.svg'
import { useTranslation } from 'react-i18next'
import { Tooltip } from '@material-ui/core'

const WithTooltip = ({ condition, title, children, ...props }) => {
  if (condition) {
    return (
      <Tooltip title={title} placement="top" arrow {...props}>
        <span>{children}</span>
      </Tooltip>
    )
  }
  return children
}

export default function RadioGroupButtons({
  options,
  label,
  onChangeProps,
  defaultValue,
  primary,
  validationErrorCheckbox,
  validation,
  formFieldName,
  value,
  disabled,
  ...props
}: any) {
  const { t } = useTranslation()

  useEffect(() => {
    if (validation && value !== undefined && value !== null) {
      validation(value, options, formFieldName)
    }
  }, [value, options, validation, formFieldName])

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChangeProps((event.target as HTMLInputElement).value)
  }

  const getLabel = (option) => {
    return (
      <WithTooltip title={option.tooltip} condition={!!option.tooltip}>
        <span>{typeof option.value === 'string' ? t(option.value) : option.value}</span>
      </WithTooltip>
    )
  }

  return (
    <StyledMultiSelect>
      <FormControl component="fieldset">
        <FormLabel component="legend">{label}</FormLabel>
        <RadioGroup
          row
          aria-label="position"
          name="position"
          defaultValue={defaultValue}
          value={`${value}`}
          onChange={handleChange}
          key={value === null || value === undefined ? 'cleared' : 'set'}
          {...props}
        >
          {options.map((option, index) => (
            <FormControlLabel
              key={option.key + index}
              value={`${option.key}`}
              control={
                <Radio
                  icon={
                    <img src={validationErrorCheckbox ? radioValidation : radioUnchecked} alt="" />
                  }
                  checkedIcon={<img src={radioChecked} alt="" />}
                  disabled={disabled}
                />
              }
              label={getLabel(option)}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </StyledMultiSelect>
  )
}
